module.exports = __webpack_public_path__ + "static/191108-BS-F1-Banner-NCoin-Promo-cf8259ff39c6dd48bead7be4681ec376.jpg";